import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import Select from '../common/AppSelect';

import '../common/MdPage.css';

import * as constantClass from '../fileWithConstants';

import { ChevronLeftIcon } from '../common/mdPageIcons';

import * as historiaAcademicaService from '../../services/historiaAcademica/historiaAcademicaService';

import * as carrerasService from '../../services/carreras/carrerasService';

import {

  classifyCarrerasError,

  mapCarrerasToSelectOptions,

} from '../../services/carreras/carrerasDto';

import {

  classifyHistoriaAcademicaError,

  validateActualizarRegularidadesForm

} from '../../services/historiaAcademica/historiaAcademicaDto';



export class ActualizarRegularidades extends Component {

  static displayName = ActualizarRegularidades.name;



  constructor(props) {

    super(props);

    this.state = {

      loading: false,

      loadingCarreras: true,

      carreraOptions: [],

      code: "",

      name: "",

      anioDictado: "",

      dictado: "",

      showErrorMessage: false,

      success: false,

      errorMessage: "",

      tagData: [{id:"",text:""}],

      alumno: { alumnoDni: "", alumnoCodigo: 0, alumnoNombre: "" },

      carrera: { codigo: "", nombre: "" },

      showLookupStudent: false,

      showLookupCarreras: false,

      practica: "",

      value: { value: '', label: '' },

      valueDictado: { value: '', label: '' },

      name:""

    };

    this.handleConfirmButton = this.handleConfirmButton.bind(this);

    this.handleDelete = this.handleDelete.bind(this);

    this.handleSelectCarreraItem = this.handleSelectCarreraItem.bind(this);

    this.handleShowCarreraLookup = this.handleShowCarreraLookup.bind(this);

    this.handleCodeChange = this.handleCodeChange.bind(this);

    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);

    this.handleSelect = this.handleSelect.bind(this);

    this.handleDictadoChangeInput = this.handleDictadoChangeInput.bind(this);

    this.handleAnioChangeInput = this.handleAnioChangeInput.bind(this);

    this.handleHideLookup = this.handleHideLookup.bind(this);

  }



  handleConfirmButton = () => {

    if (validateActualizarRegularidadesForm({ carreraCodigo: this.state.dictado })) {

      this.saveStudent();

    } else {

      this.setState({ showErrorMessage: true, errorMessage: "Todos los campos son obligatorios" });

    }

  }



  async componentDidMount() {

    const canAccess = await constantClass.canAccess('HistoriaAcademicaCursada');

    if (canAccess) {

      await this.loadCarreras();

    }

  }



  async loadCarreras() {

    this.setState({ loadingCarreras: true, showErrorMessage: false, errorMessage: '' });

    try {

      const { items } = await carrerasService.listCarreras({ page: 1, pageSize: 500 });

      this.setState({

        carreraOptions: mapCarrerasToSelectOptions(items),

        loadingCarreras: false,

      });

    } catch (error) {

      const outcome = classifyCarrerasError(error);

      if (outcome.type === 'timeout') {

        constantClass.RedirectToLogin();

        return;

      }

      this.setState({

        loadingCarreras: false,

        showErrorMessage: true,

        errorMessage: outcome.message,

      });

    }

  }



  handleSelectCarreraItem = (e) =>

  {

    const carreraProperties = e.split('%');

    this.setState({

      showLookupCarreras: false,

      carrera: {

        codigo: carreraProperties[0],

        nombre: carreraProperties[1]

      }

    });

  }



  handleSelect = e => {

    this.setState({ practica: e.value, value: e });

  }



  handleHideLookup = () =>

  {

    this.setState({showLookupCarreras:false});

  }



  handleShowCarreraLookup = () =>

  {

    this.setState({showLookupCarreras:true});

  }



  handleNameChangeInput = e => {

    this.setState({ name: e.target.value });

  }



  handleAnioChangeInput = e => {

    this.setState({ anioDictado: e.target.value });

  }



  handleDictadoChangeInput = e => {

    this.setState({ dictado: e.value, valueDictado:e });

  }



  handleCodeChange = e => {

    this.setState({ code: e.target.value });

  }



  handleDelete = (i) => {

    this.setState({tagData:this.state.tagData.filter(tag =>tag.id !== i)});

  }



  render() {

    const { loading, loadingCarreras } = this.state;

    const isBusy = loading || loadingCarreras;



    return (

      <div className="md-page md-actualizar-regularidades">

        <Link className="md-page__back-link" to="/md-hic">

          <ChevronLeftIcon />

          Volver al listado

        </Link>



        <div className="md-page__header">

          <h1 className="md-page__title">Actualizar Regularidades por Carrera</h1>

        </div>

        <p className="md-page__subtitle">

          Seleccione la carrera para actualizar las regularidades de sus alumnos.

        </p>



        <div className="md-page__feedback" aria-live="polite" role="status">

          {this.state.showErrorMessage ? (

            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>

          ) : null}

          {loadingCarreras ? (

            <div className="md-page__status">Cargando carreras...</div>

          ) : null}

          {loading ? (

            <div className="md-page__status">Los datos se está actualizando, espere unos segundos...</div>

          ) : null}

          {this.state.success && !loading ? (

            <div className="md-page__success">Regularidades actualizadas exitosamente</div>

          ) : null}

        </div>



        <div className="md-page__form-card">

          <div className="md-page__field">

            <span className="md-page__field-label">Carrera</span>

            <Select

              className="md-page__field-select"

              value={this.state.valueDictado}

              options={this.state.carreraOptions}

              onChange={this.handleDictadoChangeInput}

              disabled={isBusy || this.state.carreraOptions.length === 0}

            />

          </div>



          <div className="md-page__form-actions">

            <button

              type="button"

              className="md-page__form-btn md-page__form-btn--primary"

              onClick={this.handleConfirmButton}

              disabled={isBusy || this.state.carreraOptions.length === 0}

            >

              Confirmar

            </button>

          </div>

        </div>

      </div>

    );

  }



  handleHistoriaAcademicaError(error, prefix = '') {

    const outcome = classifyHistoriaAcademicaError(error);

    if (outcome.type === 'timeout') {

      constantClass.RedirectToLogin();

      return { success: false, errorMessage: '' };

    }

    return {

      success: false,

      errorMessage: outcome.message

    };

  }



  async saveStudent() {

    this.setState({ showErrorMessage: false, loading: true });

    try {

      await historiaAcademicaService.actualizarRegularidadesPorCarrera(this.state.dictado);

      this.setState({ loading: false, success: true, errorMessage: "" });

    } catch (error) {

      const outcome = this.handleHistoriaAcademicaError(error);

      this.setState({

        loading: false,

        success: false,

        showErrorMessage: true,

        errorMessage: outcome.errorMessage,

      });

    }

  }

}


